import * as React from "react";
import {BookmarkItem} from "./bookmarks_model";
import clsx from "clsx";

interface BookmarkRendererProps {
    bookmarkItem: BookmarkItem,
    extraLiClass: string,
    highlighter: (txt: String) => JSX.Element
}


export default React.memo((props: BookmarkRendererProps) => {

    const bookmark = props.bookmarkItem;
    const classes = clsx("bookmarkItemLi", props.extraLiClass);

    const icon = 'searchEverywhere__icon' + (bookmark.icon ? ` ${bookmark.icon}` : '');

    return <li className={classes} id={"bookmark_" + bookmark.id} key={"bookmark_" + bookmark.id}
               title={bookmark.title}>
        <span className={icon}/>

        <a href={bookmark.url} target="_blank">{props.highlighter(bookmark.text)}</a>

        <span className='searchEverywhere__shortcut'
              dangerouslySetInnerHTML={{__html: bookmark.shortcut}}
        />
    </li>
}, (oldP, newP) => {
    return oldP.bookmarkItem.id === newP.bookmarkItem.id &&
        oldP.bookmarkItem.text === newP.bookmarkItem.text &&
           oldP.bookmarkItem.shortcut === newP.bookmarkItem.shortcut &&
           oldP.extraLiClass === newP.extraLiClass;
})